import { Box, Button, Stack, TextField, Typography } from "@mui/material";
import { FieldArray, getIn, useField, useFormikContext } from "formik";
import type { AddSolutionFormValues } from "../../../add/form/types";
import type { EditSolutionFormValues } from "../../../edit/form/types";
import type { UniqueBenefitsInputsProps } from "../../types";
import MissingTableValue from "./MissingTableValue";

function BenefitField({ index }: { index: number }) {
  const [field, meta] = useField<string>(`assessmentReport.benefits.${index}`);
  return (
    <TextField
      {...field}
      label={`Benefit ${index + 1}`}
      variant="standard"
      fullWidth
      error={Boolean(meta.error)}
      helperText={meta.error}
    />
  );
}

function UniqueBenefitsInputs({
  showEmptyValidation = false,
}: UniqueBenefitsInputsProps) {
  const context = useFormikContext<
    AddSolutionFormValues | EditSolutionFormValues
  >();
  const benefitsError = getIn(context.errors, "assessmentReport.benefits");
  const arrayError =
    typeof benefitsError === "string" ? benefitsError : undefined;

  return (
    <FieldArray name="assessmentReport.benefits">
      {({ push, remove }) => (
        <Stack spacing={2}>
          <Typography variant="h6">Unique benefits</Typography>
          {context.values.assessmentReport.benefits.length === 0 ? (
            showEmptyValidation && arrayError ? (
              <MissingTableValue message={arrayError} />
            ) : null
          ) : (
            context.values.assessmentReport.benefits.map((_benefit, index) => (
              <Stack
                key={`assessment-benefit-${index}`}
                direction={{ xs: "column", md: "row" }}
                spacing={1}
                alignItems="flex-start"
              >
                <BenefitField index={index} />
                <Button
                  variant="outlined"
                  color="error"
                  onClick={() => remove(index)}
                >
                  Remove
                </Button>
              </Stack>
            ))
          )}
          <Box>
            <Button variant="outlined" onClick={() => push("")}>
              Add benefit
            </Button>
          </Box>
        </Stack>
      )}
    </FieldArray>
  );
}

export default UniqueBenefitsInputs;
